import { inject, Injectable } from '@angular/core';
import { ConfirmationService, Confirmation } from '@abp/ng.theme.shared';
import { ABP, ListService, PagedResultDto } from '@abp/ng.core';
import { filter, switchMap } from 'rxjs/operators';
import type {
  GetWhatsAppContactsInput,
  WhatsAppContactDto,
} from '../../../proxy/whats-app-contacts/models';
import { WhatsAppContactService } from '../../../proxy/whats-app-contacts/whats-app-contact.service';

@Injectable()
export class WhatsAppContactViewService {
  protected readonly proxyService = inject(WhatsAppContactService);
  protected readonly confirmationService = inject(ConfirmationService);
  protected readonly list = inject(ListService);

  data: PagedResultDto<WhatsAppContactDto> = {
    items: [],
    totalCount: 0,
  };

  filters = {} as GetWhatsAppContactsInput;

  delete(record: WhatsAppContactDto) {
    this.confirmationService
      .warn('::DeleteConfirmationMessage', '::AreYouSure', { messageLocalizationParams: [] })
      .pipe(
        filter(status => status === Confirmation.Status.confirm),
        switchMap(() => this.proxyService.delete(record.id)),
      )
      .subscribe(this.list.get);
  }

  hookToQuery() {
    const getData = (query: ABP.PageQueryParams) =>
      this.proxyService.getList({
        ...query,
        ...this.filters,
        filterText: query.filter,
      });

    const setData = (list: PagedResultDto<WhatsAppContactDto>) => {
      this.data = list;
    };

    this.list.hookToQuery(getData).subscribe(setData);
  }

  clearFilters() {
    this.filters = {} as GetWhatsAppContactsInput;
    this.list.get();
  }
}
